import { PolicyNumberPrefix, YouCantMakeAClaimContent, useFormotiv } from "raci-react-library";
import { useEffect } from "react";
import useFlowState from "../../shared/components/FlowStateProvider/useFlowState";
import { FORMOTIV_CONFIG } from "../../shared/constants";
import { ErrorRoute } from "../../shared/routing/routes.config";

export const YouCantMakeAClaim = () => {
  const [, setFlowCompleted] = useFlowState();
  const { formotivOnSubmitWrapper } = useFormotiv(FORMOTIV_CONFIG);

  useEffect(() => {
    formotivOnSubmitWrapper(() => {
      setFlowCompleted(ErrorRoute.YouCantMakeAClaim);
    })({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <YouCantMakeAClaimContent policyNumberPrefix={PolicyNumberPrefix.Motor} />;
};

export default YouCantMakeAClaim;
